export default __webpack_public_path__ + "static/media/icon-8.7853e4bc.png";